import { render } from "./MasterEstruturaNo.vue?vue&type=template&id=43e87f97&scoped=true"
import script from "./MasterEstruturaNo.vue?vue&type=script&lang=js"
export * from "./MasterEstruturaNo.vue?vue&type=script&lang=js"

import "./MasterEstruturaNo.vue?vue&type=style&index=0&id=43e87f97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43e87f97"]])

export default __exports__